"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'taskListByASM',
      apiModule: 'kpiSet',
      optConfig: {
        planTypeOptions: [],
        yesnoOptions: [],
        collaborativeOptions: []
      },
      searchQuery: {
        asmEmpName: '',
        planTaskStartDate: '',
        planTaskEndDate: '',
        planTaskType: '',
        collaborativeFlag: ''
      }
    };
  },
  computed: {
    // 支持对日期、ASM名称、任务类型、是否协同访店进行筛选
    domData: function domData() {
      return {
        asmEmpName: {
          label: this.$t('sfe.pattenkpi.asmName'),
          valueKey: 'asmEmpName'
        },
        timeRange: {
          label: this.$t('common.date'),
          valueKey: 'timeRange',
          inputType: 'daterange',
          keyList: ['planTaskStartDate', 'planTaskEndDate']
        },
        planTaskType: {
          label: this.$t('sfe.taskListByASM.planTaskType'),
          valueKey: 'planTaskType',
          inputType: "select",
          options: this.optConfig.planTypeOptions,
          optionLabel: 'name',
          optionValue: 'code'
        },
        collaborativeFlag: {
          label: this.$t('sfe.taskListByASM.collaborativeFlag'),
          valueKey: 'collaborativeFlag',
          inputType: "select",
          options: this.optConfig.collaborativeOptions,
          optionLabel: 'name',
          optionValue: 'code'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.tasklistbyasm'),
          apiUrl: '/protected/pc/report/asmTask/export'
        }
      };
    },
    tableDom: function tableDom() {
      return {
        asmEmpNo: {
          label: this.$t('sfe.pattenkpi.asmId')
        },
        asmEmpName: {
          label: this.$t('sfe.pattenkpi.asmName')
        },
        planTaskDate: {
          label: this.$t('common.date')
        },
        planTaskActualStartTime: {
          label: this.$t('common.startTime')
        },
        planTaskActualEndTime: {
          label: this.$t('common.endTime')
        },
        planTaskType: {
          label: this.$t('sfe.taskListByASM.planTaskType')
        },
        planTaskFlag: {
          label: this.$t('sfe.taskListByASM.planTaskFlag')
        },
        rtlFullName: {
          label: this.$t('sfe.taskListByASM.rtlFullName')
        },
        customerName: {
          label: this.$t('sfe.taskListByASM.customerName')
        },
        customerAddress: {
          label: this.$t('sfe.taskListByASM.customerAddress')
        },
        visitPurposeOne: {
          label: this.$t('sfe.taskListByASM.visitPurposeOne')
        },
        visitPurposeTwo: {
          label: this.$t('sfe.taskListByASM.visitPurposeTwo')
        },
        asmVisitPurpose: {
          label: this.$t('sfe.taskListByASM.asmVisitPurpose')
        },
        collaborativeFlag: {
          label: this.$t('sfe.taskListByASM.collaborativeFlag')
        },
        srEmpNo: {
          label: this.$t('sfe.taskListByASM.srEmpNo')
        },
        srEmpName: {
          label: this.$t('sfe.taskListByASM.srEmpName')
        },
        remark: {
          label: this.$t('sfe.taskListByASM.remark')
        },
        asmVisitSummary: {
          label: this.$t('sfe.taskListByASM.asmVisitSummary')
        }
      };
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/pc/report/asmTask/list'
      };
    }
  },
  mounted: function mounted() {
    // 获取下拉选项
    this.queryEnumOptions();
  },
  methods: {
    queryEnumOptions: function queryEnumOptions() {
      var _this = this;
      var type_key = "PLAN_TASK_TYPE"; // 计划任务select
      var yesno_key = "Y_OR_N"; // 是与否
      var collaborative_flag = "COLLABORATIVE_FLAG"; // 协同访店
      var param = {
        configItemCodeList: [type_key, yesno_key, collaborative_flag]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        var typeKeyArr = data[type_key];
        // 去掉潜在客户拜访
        // {itemCode: "PLAN_TASK_TYPE", code: "A10", name: "潜在客户拜访", language: "zh"}
        var codeToRemove = 'A10';
        var reducedTypeKeyArr = typeKeyArr.reduce(function (acc, curr) {
          if (curr.code !== codeToRemove) {
            acc.push(curr);
          }
          return acc;
        }, []);
        _this.optConfig.planTypeOptions = reducedTypeKeyArr || [];
        _this.optConfig.yesnoOptions = data[yesno_key] || [];
        _this.optConfig.collaborativeOptions = data[collaborative_flag] || [];
      });
    }
  }
};